<template>
  <div class="moneyBag acccont">
    <div class="acctit">
      <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
      {{$t('account.wallet')}}
      <div class="addbtn btnn" @click="addBag"><i class="el-icon-circle-plus-outline"></i>{{$t('account.wallet_add')}}
      </div>
    </div>
    <div class="bagsbox">
      <div class="bagitem texal" v-for="(item, index) in lists" :key="index+'bag'">
        <div class="bagtit">{{item.name}}</div>
        <div class="codebox">{{item.address}}</div>
        <div class="texar">
          <div class="addbtn2 disinline btnn" @click="editBag(item)"><i
              class="el-icon-edit"></i>{{$t('account.wallet_edit2')}}</div>
          <div class="addbtn2 disinline btnn" @click="deleteBag(item.id)"><i
              class="el-icon-delete"></i>{{$t('account.wallet_delete')}}
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="func" :visible.sync="dialogVisible" width="35%">
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
        <el-form-item :label="$t('account.wallet_type')">
          <el-select v-model="ruleForm.type" class="selebox" :placeholder="$t('account.select_wallet_type')">
            <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.wallet_address2')">
          <el-input prefix-icon="el-icon-location" v-model="ruleForm.address"
            :placeholder="$t('account.input_wallet_address')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.trader_password')">
          <el-input prefix-icon="el-icon-key" type="password" v-model="ruleForm.pay_password"
            :placeholder="$t('account.input_trader_password')" autocomplete="off"></el-input>
        </el-form-item>
        <div class="btnn bgb texac" @click="submitForm">{{$t('account.save')}}</div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  // @ is an alias to /src
  import {
    getList,
    addOrUpdate,
    deleteWallet
  } from '@/api/wallet'

  export default {
    name: 'moneyBag',
    data() {
      return {
        lists: [],
        ruleForm: {
          id: 0,
          type: '1',
          address: '',
          pay_password: ''
        },
        options: [{
          value: '1',
          label: 'ERC20'
        }, {
          value: '2',
          label: 'TRC20'
        }],
        func: this.$t('account.wallet_add'),
        dialogVisible: false
      }
    },
    computed: {
      isApp() {
        return document.documentElement.clientWidth < 800 ? true : false
      },
      routeName() {
        console.log(this.$route.path)
        return this.$route.path
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        getList().then(res => {
          console.log(res)
          const data = res.data
          this.lists = data.lists

        }).catch(_ => {

        })
      },
      returnpage() {
        this.$router.go(-1)
      },
      submitForm() {
        if (this.ruleForm.address.length < 10) {
          this.$message.error(this.$t('account.input_right_wallet_address'))
          return false
        }
        if (this.ruleForm.pay_password.length == 0) {
          this.$message.error(this.$t('account.input_your_trader_password'))
          return false
        }

        this.submit()
      },
      submit() {
        let params = {
          ...this.ruleForm
        }
        let that = this
        addOrUpdate(params).then(res => {
          if (res.code == 1) {
            this.$message.success(res.msg)
            this.dialogVisible = false
            setTimeout(function() {
              that.getData();
            }, 500);
          } else {
            this.$message.error(res.msg)
          }

        }).catch(_ => {

        })

      },
      delete(id, pwd) {
        let that = this
        deleteWallet({
          id: id,
          pay_password: pwd
        }).then(res => {
          if (res.code == 1) {
            this.$message.success(res.msg)
            setTimeout(function() {
              that.getData();
            }, 500);
          } else {
            this.$message.error(res.msg)
          }

        }).catch(_ => {

        })

      },
      editBag(obj) {
        this.ruleForm.id = obj.id
        this.ruleForm.type = obj.type.toString()
        this.ruleForm.address = obj.address
        this.ruleForm.pay_password = ''
        this.func = this.$t('account.wallet_edit')
        if (this.isApp) {
          this.$router.push({
            path: '/home/addBag?usefun=edit&id=' + obj.id
          })
        } else {
          this.dialogVisible = true
        }
      },
      deleteBag(id) {
        let that = this
        this.$prompt(
          this.$t('account.trader_password'),
          this.$t('account.trader_tips'), {
            confirmButtonText: this.$t('account.trader_confirm'),
            cancelButtonText: this.$t('account.trader_cancel'),
            type: "warning", // 图标样式 "warning"|"error"...
            inputValue: '',
            inputErrorMessage: '',
            customClass: 'message-logout',
            inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
              if (!value) {
                return this.$t('account.input_your_trader_password');
              }
            },
            callback: function(action, instance) {
              if (action === 'confirm') {
                // do something...
                that.delete(id, instance.inputValue)
              }
            }
          }).then(({
          value
        }) => {
          console.log(value);
          // TO DO DO ...
        }).catch((err) => {
          console.log(err);
        })
      },
      addBag() {
        this.ruleForm.id = 0
        this.ruleForm.address = '';
        this.ruleForm.pay_password = ''
        this.func = this.$t('account.wallet_add')
        if (this.isApp) {
          this.$router.push({
            path: '/home/addBag?usefun=add&id=0'
          })
        } else {
          this.dialogVisible = true
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .moneyBag {
    .acctit {
      position: relative;

      .addbtn {
        position: absolute;
        right: 20px;
        top: 2px;
        font-size: 20px;
        color: rgb(37, 72, 231);
      }
    }

    .bagsbox {
      padding: 30px;
      box-sizing: border-box;
    }

    .bagitem {
      padding: 20px;
      border-radius: 10px;
      width: 60%;
      margin: 20px;
      font-size: 20px;
      border: 1px solid #888888;

      .texar {
        text-align: right;
      }

      .bagtit {
        font-size: 26px;
        line-height: 60px;
        margin-bottom: 10px;
      }

      .codebox {
        line-height: 20px;
      }

      .disinline {
        display: inline-block;
      }

      .addbtn2 {
        margin: 20px 20px;
      }
    }



  }

</style>
<style>
  @media (max-width: 730px) {
    .message-logout {
      width: 92% !important;
    }
  }
</style>
